import {
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  useQuery,
  useQueryClient,
} from 'react-query';
import { AIFillAppAPI } from 'api/ai-fill';
import { AiFillApp, AiFillConfig, CustomAiFillApp } from 'api/ai-fill/types';
import { getAIFillAppId } from 'components/organisms/ai-fill/utils';

export const AI_FILL_APPS_KEY = ['ai-fill-apps'];
export const useGetAiFillApps = (
  queryOptions: UseQueryOptions<
    AiFillApp[],
    unknown,
    AiFillApp[],
    typeof AI_FILL_APPS_KEY
  > = {},
): UseQueryResult<AiFillApp[]> =>
  useQuery(AI_FILL_APPS_KEY, () => AIFillAppAPI.getAIFillApps(), queryOptions);

export const useCreateAiFillAppMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<AiFillApp, unknown, AiFillConfig>(
    (payload) => AIFillAppAPI.createAIFillApp(payload),
    {
      onSuccess: (_createdApp) => {
        queryClient.invalidateQueries(AI_FILL_APPS_KEY);
        // queryClient.setQueryData(AI_FILL_APPS_KEY, (previous?: AiFillApp[]) =>
        //   (previous ?? []).concat(createdApp),
        // );
      },
    },
  );
};

export const useUpdateAiFillAppMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<
    AiFillApp,
    unknown,
    { app: CustomAiFillApp; config: AiFillConfig }
  >(({ app, config }) => AIFillAppAPI.updateAIFillApp(app, config), {
    onSuccess: (updatedApp, { app }) => {
      queryClient.setQueryData(AI_FILL_APPS_KEY, (previous?: AiFillApp[]) =>
        (previous ?? [])
          .filter((aiFillApp) => getAIFillAppId(aiFillApp) !== app.aiFillAppId)
          .concat(updatedApp),
      );
    },
  });
};
export const useDeleteAiFillAppMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, CustomAiFillApp>(
    (app) => AIFillAppAPI.deleteAIFillApp(app),
    {
      onSuccess: (_, app) => {
        queryClient.setQueryData(AI_FILL_APPS_KEY, (previous?: AiFillApp[]) =>
          (previous ?? []).filter(
            (aiFillApp) => getAIFillAppId(aiFillApp) !== app.aiFillAppId,
          ),
        );
      },
    },
  );
};
